import React from 'react';

import { AddressProvider } from '@/models/address';
import { CouponProvider } from '@/models/coupon';
import { InvoiceProvider } from '@/models/invoice';

const Index: React.FC<any> = (props) => {
  return (
    <AddressProvider>
      <InvoiceProvider>
        <CouponProvider>{props.children}</CouponProvider>
      </InvoiceProvider>
    </AddressProvider>
  );
};

export default Index;
